import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { BookOpen, Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const OpenerFixButton = ({ kit, reload, disabled }) => {
  const [starting, setStarting] = useState(false);
  const was = useRef(false);
  const busy = starting || kit.filling;

  useEffect(() => {
    if (was.current && !kit.filling) {
      const r = kit.opener_result || {};
      if (r.error) toast.error(`Opener fix failed: ${r.error}`);
      else if (r.still) toast.warning(`Intros written for ${r.fixed} opener(s) — ${r.still} still under 85%. Run again or edit by hand.`);
      else toast.success(r.fixed ? `Intros written — ${r.fixed} opener page(s) now pass` : "Every chapter opener already passes 85%");
      was.current = false;
    }
  }, [kit.filling, kit.opener_result]);

  const go = async () => {
    setStarting(true);
    try {
      await http.post(`/kits/${kit.id}/fix-openers`);
      toast.message("Writing short intros for thin chapter openers — a few minutes");
      was.current = true;
      await reload();
    } catch (e) { toast.error(errMsg(e)); }
    setStarting(false);
  };

  return (
    <button data-testid="fix-openers-button" onClick={go} disabled={disabled || busy}
      title="Add a short intro to chapter opener pages that are under 85% full"
      className="inline-flex items-center gap-2 rounded-sm border border-stone-300 px-4 py-2 text-sm text-stone-600 hover:text-stone-900 hover:bg-stone-100 transition-colors disabled:opacity-40">
      {busy ? <Loader2 size={15} className="animate-spin" /> : <BookOpen size={15} />}
      Fix thin openers
    </button>
  );
};
